import { FxIcon } from '@/components/fx'

/**
 * The threshold, as a control over *this view* and nothing else.
 *
 * Moving it re-filters the fields already loaded — no round trip, no write.
 * That is deliberate: `confidenceThreshold` on the template decides what
 * every future analysis flags and what the exports call unclear, and nudging
 * a slider on a review screen is not how someone should change that for the
 * whole form and everyone who shares it. The label says which of the two this
 * is, so nobody comes back tomorrow expecting 60 %.
 */
export function ThresholdSlider({
  value,
  onChange,
}: {
  /** 0..1, as the template stores it. */
  value: number
  onChange: (value: number) => void
}) {
  const percent = Math.round(value * 100)
  return (
    <div className="flex items-center gap-2">
      <FxIcon name="tune" size={22} className="text-primary-text" />
      <label htmlFor="bulk-threshold" className="text-small">
        Schwellwert
      </label>
      <input
        id="bulk-threshold"
        type="range"
        min={0}
        max={100}
        step={5}
        value={percent}
        onChange={(event) => onChange(Number(event.target.value) / 100)}
        aria-valuetext={`${percent} Prozent`}
        className="h-1 w-40 cursor-pointer appearance-none rounded-full bg-fill accent-primary-strong"
      />
      <b className="w-12 text-small">{percent} %</b>
      {/* Visible, not `sr-only`: the identical-looking slider in the form's
          settings *does* persist, and a sighted person has no other way to
          tell the two apart. */}
      <span className="text-small text-text-muted">nur für diese Ansicht</span>
    </div>
  )
}
